import request from "@/plugins/ecommerce_axios";
import { defineStore } from "pinia";
import { reactive, ref } from "vue";
import { useCartStore } from "./CartStore";
import { useAuthSiteStore } from "./AuthStore";
import { SaveLayoutAfiliado, GetVitrineGerenciamento, ToggleProductVisibility, TogglePromotionVisibility } from "@/services/backend/Affiliate";
import { Notification } from "@/plugins/notifications";
// import { useTheme } from "vuetify";

export const useAffiliateStore = defineStore('affiliate', () => {
  const authSiteStore = useAuthSiteStore()
  const cartStore = useCartStore()
  // const theme = useTheme() // Pega o objeto de tema do Vuetify

  const affiliate = ref(null)
  const erroGetAffiliate = ref(null)
  const isLoadingGetAffiliate = ref(false)
  const isLoadingAffiliate = ref(false)
  const layout = reactive({
    uuid: null,
    logo: null,
    logo_url: null,
    background_color: null,
    primary_color: null,
    afiliado_uuid: null
  })

  const vitrine = reactive({
    produtos: [],
    promocoes: [],
    isLoading: false
  })

  async function FetchVitrineGerenciamento(afiliadoUuid, filters = {}) {
    try {
      vitrine.isLoading = true
      const data = {
        afiliado_uuid: afiliadoUuid,
        ...filters
      }
      const response = await GetVitrineGerenciamento(data)
      if (response.status === 'success') {
        vitrine.produtos = response.data.produtos
        vitrine.promocoes = response.data.promocoes
      }
    } catch (error) {
      console.log(error)
      Notification.error('Erro ao carregar vitrine')
    } finally {
      vitrine.isLoading = false
    }
  }

  async function ToggleVisibility(tipo, itemUuid, isHidden, afiliadoUuid) {
    try {
      const data = {
        afiliado_uuid: afiliadoUuid,
        is_hidden: isHidden
      }
      let response
      if (tipo === 'produto') {
        data.produto_uuid = itemUuid
        response = await ToggleProductVisibility(data)
      } else {
        data.promocao_uuid = itemUuid
        response = await TogglePromotionVisibility(data)
      }

      if (response.status === 'success') {
        Notification.success(response.message)
        return true
      }
    } catch (error) {
      console.log(error)
      Notification.error('Erro ao atualizar visibilidade')
      return false
    }
  }

  async function GetAffiliate(affiliateCode) {

    try {
      isLoadingGetAffiliate.value = true

      const response = await request.get(`/afiliado/${affiliateCode}`)
      if (response.data.status === 'success') {
        affiliate.value = response.data.data
        if (affiliateCode != affiliate.value.code) {
          cartStore.CleanPurchaseCart()
        }
      } else {
        affiliate.value = null
      }

    } catch (error) {
      erroGetAffiliate.value = error.response.data.message
      affiliate.value = null
    } finally {
      isLoadingGetAffiliate.value = false
    }
  }

  async function SaveLayoutAffiliateSettings(formData) {
    try {
      isLoadingAffiliate.value = true
      const response = await SaveLayoutAfiliado(formData)
      if (response.status === 'success' || [200,201].includes(response.status)) {
        Notification.success(response.message)
        await FetchLayoutAffiliateSettings()
        return true
      }
      return false
    } catch (error) {
      console.log(error);
      Notification.error(error.response?.data?.message || 'Erro ao salvar o layout')
      return false
    } finally {
      isLoadingAffiliate.value = false
    }
  }

  const FetchLayoutAffiliateSettings = async () => {

    try {
      isLoadingAffiliate.value = true
      const affiliate_uuid = affiliate.value?.uuid ?? authSiteStore.user.affiliate?.uuid
      const response = await request.get(`afiliado/layout/get/${affiliate_uuid}`);
      if (response.status === 200) {
        layout.uuid = response.data.data.uuid
        layout.logo = response.data.data.logo
        layout.background_color = response.data.data.background_color
        layout.primary_color = response.data.data.primary_color
        layout.logo_url = response.data.data.logo_url
        layout.afiliado_uuid = response.data.data.afiliado.uuid
        // SetLayoutSettings()
      }
    } catch (error) {
      layout.primary_color = null
      if (error.status != 404) {
        Notification.error(error.response.data.message)
      }
    } finally {
      isLoadingAffiliate.value = false
    }
  }

  // const SetLayoutSettings = () => {
  //   const currentThemeName = theme.global.name.value
  //   theme.themes.value[currentThemeName].colors.primary = "#cecece"
  // }

  return {
    affiliate,
    erroGetAffiliate,
    isLoadingGetAffiliate,
    isLoadingAffiliate,
    layout,
    vitrine,
    GetAffiliate,
    FetchLayoutAffiliateSettings,
    SaveLayoutAffiliateSettings,
    FetchVitrineGerenciamento,
    ToggleVisibility
  }
})